import { IAppState } from '../../common/state';
import { AUDIENCE_ONETWOTRIP_BANNER } from '../../constants/experiments';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';
import { abUseExperimentsSelector } from '../commonSelectors';

export function selectOneTwoTripBannerExperimentEnabled(state: IAppState): boolean {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentGroup(experiments, AUDIENCE_ONETWOTRIP_BANNER, 'enabled');
}
